import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import "@/shared/config/i18n";
import "@/shared/api/client"; // installs axios interceptors
import { queryClient } from "@/shared/api/queryClient";
import { ToastProvider } from "@/shared/ui/Toast";
import { App } from "./App";
import "../index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
